import React from 'react';
import './BreadCrumb.css';
import { NavLink } from "react-router-dom";

const Breadcrumb = ({ paths }) => {
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {paths.map((path, index) => (
          <li key={index} className="breadcrumb-item">
            {index !== paths.length - 1 ? (
              <NavLink to={path.link}>{path.name}</NavLink>
            ) : (
              <span>{path.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
